var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "afr-info", attrs: { id: "tab-afr" } },
    [
      _c("div", { staticClass: "section operations" }, [
        _c("div", { staticClass: "triggers" }, [
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.readonly, type: "primary" },
                  on: { click: _vm.linkOperationRequirement }
                },
                [_vm._v(_vm._s(_vm.getItemTitle("Operation Requirement")))]
              ),
              _c(
                "el-dropdown",
                {
                  staticStyle: { "padding-left": "5px" },
                  attrs: {
                    disabled: _vm.readonly,
                    "split-button": "",
                    type: "primary",
                    no: "1"
                  },
                  on: {
                    click: function($event) {
                      return _vm.commandHandle(_vm.command1)
                    },
                    command: function(p) {
                      _vm.command1 = p
                      _vm.commandHandle(_vm.command1)
                    }
                  }
                },
                [
                  _vm._v(" " + _vm._s(_vm.getItemTitle(_vm.command1)) + " "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "el-dropdown-item",
                        { attrs: { command: "Copy Last Time" } },
                        [_vm._v(_vm._s(_vm.getItemTitle("Copy Last Time")))]
                      ),
                      _c(
                        "el-dropdown-item",
                        { attrs: { command: "Copy By File NO" } },
                        [_vm._v(_vm._s(_vm.getItemTitle("Copy By File NO")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _c("div", { staticStyle: { width: "fit-content" } }, [
        _c(
          "div",
          {
            staticClass: "address-format-from",
            staticStyle: { display: "flex" }
          },
          [
            _c(
              "div",
              {
                staticClass: "section form-column",
                staticStyle: { width: "50%" }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.getItemTitle("HblInfo")))
                ]),
                _c(
                  "el-form",
                  {
                    staticStyle: {
                      "margin-left": "18px",
                      "margin-right": "18px"
                    },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "110px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "auto-width",
                        attrs: { "label-width": "0" }
                      },
                      [
                        _c("cargo-ag-grid", {
                          staticStyle: { width: "100%", height: "200px" },
                          attrs: {
                            "config-module": "1001011",
                            "grid-options": _vm.afr2.gridOptions,
                            "column-defs": _vm.afr2ColumnDefs,
                            "row-data": _vm.afr2.rowData
                          },
                          on: {
                            gridReady: function(params) {
                              _vm.afr2.gridApi = params.api
                            }
                          }
                        }),
                        _c("div", { staticStyle: { padding: "5px 0" } }, [
                          _c(
                            "div",
                            { staticStyle: { float: "right" } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    title: _vm.$t("SeaExport.addHbl"),
                                    no: "5"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.onAddNewAfrCargoDoc()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.getItemTitle("Add HB/L")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    title: _vm.$t(
                                      "SeaExport.SynchronizeHBLInformation"
                                    ),
                                    no: "2"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.btnSynchroAfrClickHandler()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.getItemTitle("Import HB/L"))
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "danger",
                                    title: _vm.$t("SeaExport.Delete"),
                                    no: "4"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.onRemoveCargoDocAi()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.getItemTitle("Delete")))]
                              )
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "span",
                  {
                    staticClass: "title",
                    staticStyle: { "margin-top": "46px" },
                    attrs: { title: _vm.$t("SeaExport.PortInformation") }
                  },
                  [_vm._v(_vm._s(_vm.getItemTitle("Port Information")))]
                ),
                _c(
                  "el-form",
                  {
                    staticStyle: {
                      "margin-left": "18px",
                      "margin-right": "18px"
                    },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "110px",
                      "label-position": "top"
                    }
                  },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "blue-text",
                                attrs: {
                                  label: _vm.getItemTitle("Place of Receipt")
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  attrs: {
                                    no: "dispatchingPlaceCode",
                                    filterable: "",
                                    "static-options": _vm.protList,
                                    cache: false,
                                    "tag-value": "code",
                                    "filter-tag-names": ["code", "englishName"],
                                    "default-value":
                                      _vm.form.dispatchingPlaceCode,
                                    "tag-name": "englishName",
                                    "show-custom-label-in-option": true,
                                    "custom-label": function(item) {
                                      return _vm.customLabelHandler(
                                        "Place of Receipt",
                                        item
                                      )
                                    }
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.form.dispatchingPlaceCode = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "blue-text",
                                attrs: {
                                  label: _vm.getItemTitle("Place of Discharge")
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  attrs: {
                                    "static-options": _vm.protList,
                                    cache: false,
                                    "tag-value": "code",
                                    filterable: "",
                                    "filter-tag-names": ["code", "englishName"],
                                    "default-value":
                                      _vm.form.dischargingPortCode || "",
                                    "tag-name": "englishName",
                                    no: "dischargingPortCode",
                                    "show-custom-label-in-option": true,
                                    "custom-label": function(item) {
                                      return _vm.customLabelHandler(
                                        "Place of Discharge",
                                        item
                                      )
                                    }
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.form.dischargingPortCode = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "blue-text",
                                attrs: {
                                  label: _vm.getItemTitle("Place of Loading")
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  attrs: {
                                    filterable: "",
                                    "filter-tag-names": ["code", "englishName"],
                                    "static-options": _vm.protList,
                                    "tag-value": "code",
                                    cache: false,
                                    "default-value": _vm.form.loadingPortCode,
                                    no: "loadingPortCode",
                                    "show-custom-label-in-option": true,
                                    "custom-label": function(item) {
                                      return _vm.customLabelHandler(
                                        "Place of Loading",
                                        item
                                      )
                                    }
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.form.loadingPortCode = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "blue-text",
                                attrs: {
                                  label: _vm.getItemTitle("Place of Delivery")
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  attrs: {
                                    filterable: "",
                                    "filter-tag-names": ["code", "englishName"],
                                    "static-options": _vm.protList,
                                    cache: false,
                                    "tag-value": "code",
                                    "default-value":
                                      _vm.form.destinationPortCode,
                                    no: "destinationPortCode",
                                    "show-custom-label-in-option": true,
                                    "custom-label": function(item) {
                                      return _vm.customLabelHandler(
                                        "Place of Delivery",
                                        item
                                      )
                                    }
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.form.destinationPortCode = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "span",
                  {
                    staticClass: "title",
                    staticStyle: { "margin-top": "46px" }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.DeclarationInformation")))]
                ),
                _c(
                  "el-form",
                  {
                    staticStyle: {
                      "margin-left": "18px",
                      "margin-right": "18px"
                    },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "110px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "blue-text",
                                attrs: { label: _vm.getItemTitle("Carrier") }
                              },
                              [
                                _c("cargo-advance-select", {
                                  attrs: {
                                    no: "afrScacCode",
                                    "static-options": _vm.shipCompanyInfos,
                                    cache: false,
                                    filterable: "",
                                    "filter-tag-names": [
                                      "afrScacCode",
                                      "shipCompanyCode",
                                      "shipCompanyEnglishName",
                                      "shipCompanyChineseName"
                                    ],
                                    "tag-value": "afrScacCode",
                                    "default-value": _vm.form.carrierEori,
                                    "show-custom-label-in-option": true,
                                    "custom-label": function(item) {
                                      return _vm.customLabelHandler(
                                        "Carrier",
                                        item
                                      )
                                    }
                                  },
                                  on: { parentCallBack: _vm.carrierEoriChange }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "blue-text",
                                attrs: { label: _vm.getItemTitle("SCAC CODE") }
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "",
                                      "allow-create": true,
                                      no: "37"
                                    },
                                    model: {
                                      value: _vm.form.nvoccScac,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "nvoccScac", $$v)
                                      },
                                      expression: "form.nvoccScac"
                                    }
                                  },
                                  _vm._l(_vm.localData.nvoccScacList, function(
                                    item
                                  ) {
                                    return _c("el-option", {
                                      key: item,
                                      attrs: { label: item, value: item }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "blue-text",
                                    attrs: { slot: "label" },
                                    slot: "label"
                                  },
                                  [_vm._v(_vm._s(_vm.getItemTitle("MB/L NO")))]
                                ),
                                _c("el-input", {
                                  attrs: {
                                    placeholder: _vm.showPlaceholder(
                                      "SeaExport.PleaseEnterMbl"
                                    ),
                                    disabled: _vm.readonly,
                                    no: "mbl"
                                  },
                                  model: {
                                    value: _vm.form.mbl,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "mbl", $$v)
                                    },
                                    expression: "form.mbl"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "blue-text",
                                attrs: {
                                  label: _vm.getItemTitle("VesselCallSign")
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: { no: "57" },
                                  on: {
                                    change: function($event) {
                                      return _vm.pm.syncAfrInfo("vesselCode")
                                    }
                                  },
                                  model: {
                                    value: _vm.form.vesselCode,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "vesselCode", $$v)
                                    },
                                    expression: "form.vesselCode"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "blue-text",
                                attrs: {
                                  label: _vm.getItemTitle(
                                    "Issue Departure Notice"
                                  )
                                }
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { no: "atdCompleted" },
                                    model: {
                                      value: _vm.form.atdCompleted,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "atdCompleted", $$v)
                                      },
                                      expression: "form.atdCompleted"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.getItemTitle("Sent"),
                                        value: 1
                                      }
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.getItemTitle("Not sent"),
                                        value: 2
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "section form-column",
                staticStyle: { width: "50%" }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(
                    _vm._s(_vm.getItemTitle("Sending and receiving messages"))
                  )
                ]),
                _c(
                  "el-form",
                  {
                    staticClass: "form-address",
                    staticStyle: {
                      "margin-left": "18px",
                      "margin-right": "18px"
                    },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "110px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [_vm._v(_vm._s(_vm.getItemTitle("Shipper")))]
                        ),
                        _c("cargo-company-select", {
                          staticStyle: {
                            display: "inline-block",
                            width: "200px",
                            "margin-right": "5px"
                          },
                          attrs: {
                            no: "shipperCode",
                            "method-params": { shipper: true, active: true },
                            "default-value": _vm.addressForm.shipperCode || "",
                            "allow-create": true
                          },
                          on: {
                            change: function(val) {
                              _vm.addressCodeChange(val, "shipper")
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              "vertical-align": "top",
                              "margin-left": "27px"
                            },
                            attrs: {
                              no: "shipperBtnAiRecognition",
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.aiRecognitionHandler(
                                  false,
                                  _vm.aiRecognitionPostHandlerByShipper,
                                  _vm.SystemConstants.AMS_AFR_PROMPT_KEY_ADDRESS
                                    .code
                                )
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.getItemTitle("Ai Recognition")))]
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              "vertical-align": "top",
                              "margin-left": "27px !important"
                            },
                            attrs: {
                              no: "shipperBtnCodeSearching",
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                _vm.billAddressDialog.visible = true
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue-text",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.getItemTitle("name")))]
                        ),
                        _c("el-input", {
                          attrs: {
                            placeholder: _vm.showPlaceholder(
                              "SeaExport.PleaseEnterHeader"
                            ),
                            "filter-chars": false,
                            no: "shipperLine1"
                          },
                          on: {
                            input: function($event) {
                              return _vm.afrValidateAddressField("shipperLine1")
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              return _vm.showSenderAndReceiverDialog(
                                "shipper",
                                3
                              )
                            }
                          },
                          model: {
                            value: _vm.addressForm.shipperLine1,
                            callback: function($$v) {
                              _vm.$set(_vm.addressForm, "shipperLine1", $$v)
                            },
                            expression: "addressForm.shipperLine1"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue-text",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.getItemTitle("Address1")))]
                        ),
                        _c("el-input", {
                          attrs: {
                            placeholder: _vm.showPlaceholder(
                              "SeaExport.PleaseEnterAddress"
                            ),
                            "filter-chars": false,
                            no: "shipperLine3"
                          },
                          on: {
                            input: function($event) {
                              return _vm.afrValidateAddressField("shipperLine3")
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              return _vm.showSenderAndReceiverDialog(
                                "shipper",
                                3
                              )
                            }
                          },
                          model: {
                            value: _vm.addressForm.shipperLine3,
                            callback: function($$v) {
                              _vm.$set(_vm.addressForm, "shipperLine3", $$v)
                            },
                            expression: "addressForm.shipperLine3"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [_vm._v(_vm._s(_vm.getItemTitle("Address2")))]
                        ),
                        _c("el-input", {
                          attrs: {
                            placeholder: _vm.showPlaceholder(
                              "SeaExport.PleaseEnterAddress2"
                            ),
                            "filter-chars": false,
                            no: "shipperLine4"
                          },
                          on: {
                            input: function($event) {
                              return _vm.afrValidateAddressField("shipperLine4")
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              return _vm.showSenderAndReceiverDialog(
                                "shipper",
                                3
                              )
                            }
                          },
                          model: {
                            value: _vm.addressForm.shipperLine4,
                            callback: function($$v) {
                              _vm.$set(_vm.addressForm, "shipperLine4", $$v)
                            },
                            expression: "addressForm.shipperLine4"
                          }
                        })
                      ],
                      1
                    ),
                    _c("el-form-item", [
                      _c(
                        "span",
                        {
                          staticClass: "blue-text",
                          attrs: {
                            slot: "label",
                            title: _vm.$t("SeaExport.Country")
                          },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.getItemTitle("Country")))]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                width: "40%"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    filterable: "",
                                    "filter-tag-names": [
                                      "code",
                                      "chineseName",
                                      "name"
                                    ],
                                    clearable: "",
                                    placeholder: _vm.showPlaceholder(
                                      "SeaExport.PleaseSelectCountry"
                                    )
                                  },
                                  model: {
                                    value: _vm.addressForm.shipperCountry,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.addressForm,
                                        "shipperCountry",
                                        $$v
                                      )
                                    },
                                    expression: "addressForm.shipperCountry"
                                  }
                                },
                                _vm._l(_vm.countryList, function(item) {
                                  return _c("el-option", {
                                    key: item.code,
                                    attrs: {
                                      label: _vm.customLabelHandler(
                                        "Country",
                                        item
                                      ),
                                      value: item.code
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                width: "60%"
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "center-label",
                                  staticStyle: { "text-align": "right" },
                                  attrs: { title: _vm.$t("SeaExport.ZIP") }
                                },
                                [_vm._v(_vm._s(_vm.getItemTitle("ZIP")))]
                              ),
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.showPlaceholder(
                                    "SeaExport.PleaseEnterPostalCode"
                                  ),
                                  no: "shipperPostalcode"
                                },
                                model: {
                                  value: _vm.addressForm.shipperPostalcode,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.addressForm,
                                      "shipperPostalcode",
                                      $$v
                                    )
                                  },
                                  expression: "addressForm.shipperPostalcode"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ]),
                    _c("el-form-item", [
                      _c(
                        "span",
                        {
                          staticClass: "blue-text",
                          attrs: {
                            slot: "label",
                            title: _vm.$t("SeaExport.Tel")
                          },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.getItemTitle("Tel")))]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                width: "40%"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { maxlength: "14", no: "shipperTel" },
                                model: {
                                  value: _vm.addressForm.shipperTel,
                                  callback: function($$v) {
                                    _vm.$set(_vm.addressForm, "shipperTel", $$v)
                                  },
                                  expression: "addressForm.shipperTel"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ]),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [_vm._v(_vm._s(_vm.getItemTitle("Consignee")))]
                        ),
                        _c("cargo-company-select", {
                          staticStyle: {
                            display: "inline-block",
                            width: "200px",
                            "margin-right": "5px"
                          },
                          attrs: {
                            no: "consigneeCode",
                            "method-params": { consignee: true, active: true },
                            "default-value":
                              _vm.addressForm.consigneeCode || "",
                            "allow-create": true
                          },
                          on: {
                            change: function(val) {
                              _vm.addressCodeChange(val, "consignee")
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "el-checkbox",
                          {
                            attrs: { no: "copyNotify" },
                            model: {
                              value: _vm.copyNotify,
                              callback: function($$v) {
                                _vm.copyNotify = $$v
                              },
                              expression: "copyNotify"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.getItemTitle("Copy to the notifier"))
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              "vertical-align": "top",
                              "margin-left": "10px !important"
                            },
                            attrs: {
                              no: "consigneeBtnAiRecognition",
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.aiRecognitionHandler(
                                  false,
                                  _vm.aiRecognitionPostHandlerByConsignee,
                                  _vm.SystemConstants.AMS_AFR_PROMPT_KEY_ADDRESS
                                    .code
                                )
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.getItemTitle("Ai Recognition")))]
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              "vertical-align": "top",
                              "margin-left": "10px !important"
                            },
                            attrs: {
                              no: "consigneeBtnCodeSearching",
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                _vm.billAddressDialog.visible = true
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue-text",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.getItemTitle("name")))]
                        ),
                        _c("el-input", {
                          attrs: {
                            placeholder: _vm.showPlaceholder(
                              "SeaExport.PleaseEnterHeader"
                            ),
                            "filter-chars": false,
                            no: "consigneeLine1"
                          },
                          on: {
                            input: function($event) {
                              return _vm.afrValidateAddressField(
                                "consigneeLine1"
                              )
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              return _vm.showSenderAndReceiverDialog(
                                "consignee",
                                3
                              )
                            }
                          },
                          model: {
                            value: _vm.addressForm.consigneeLine1,
                            callback: function($$v) {
                              _vm.$set(_vm.addressForm, "consigneeLine1", $$v)
                            },
                            expression: "addressForm.consigneeLine1"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue-text",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.getItemTitle("Address1")))]
                        ),
                        _c("el-input", {
                          attrs: {
                            placeholder: _vm.showPlaceholder(
                              "SeaExport.PleaseEnterAddress"
                            ),
                            "filter-chars": false,
                            no: "consigneeLine3"
                          },
                          on: {
                            input: function($event) {
                              return _vm.afrValidateAddressField(
                                "consigneeLine3"
                              )
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              return _vm.showSenderAndReceiverDialog(
                                "consignee",
                                3
                              )
                            }
                          },
                          model: {
                            value: _vm.addressForm.consigneeLine3,
                            callback: function($$v) {
                              _vm.$set(_vm.addressForm, "consigneeLine3", $$v)
                            },
                            expression: "addressForm.consigneeLine3"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [_vm._v(_vm._s(_vm.getItemTitle("Address2")))]
                        ),
                        _c("el-input", {
                          attrs: {
                            placeholder: _vm.showPlaceholder(
                              "SeaExport.PleaseEnterAddress2"
                            ),
                            "filter-chars": false,
                            no: "consigneeLine4"
                          },
                          on: {
                            input: function($event) {
                              return _vm.afrValidateAddressField(
                                "consigneeLine4"
                              )
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              return _vm.showSenderAndReceiverDialog(
                                "consignee",
                                3
                              )
                            }
                          },
                          model: {
                            value: _vm.addressForm.consigneeLine4,
                            callback: function($$v) {
                              _vm.$set(_vm.addressForm, "consigneeLine4", $$v)
                            },
                            expression: "addressForm.consigneeLine4"
                          }
                        })
                      ],
                      1
                    ),
                    _c("el-form-item", [
                      _c(
                        "span",
                        {
                          staticClass: "blue-text",
                          attrs: {
                            slot: "label",
                            title: _vm.$t("SeaExport.Country")
                          },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.getItemTitle("Country")))]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                width: "40%"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    filterable: "",
                                    "filter-tag-names": [
                                      "code",
                                      "chineseName",
                                      "name"
                                    ],
                                    clearable: "",
                                    placeholder: _vm.showPlaceholder(
                                      "SeaExport.PleaseSelectCountry"
                                    )
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.synchronizeNotifier("Country")
                                    }
                                  },
                                  model: {
                                    value: _vm.addressForm.consigneeCountry,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.addressForm,
                                        "consigneeCountry",
                                        $$v
                                      )
                                    },
                                    expression: "addressForm.consigneeCountry"
                                  }
                                },
                                _vm._l(_vm.countryList, function(item) {
                                  return _c("el-option", {
                                    key: item.code,
                                    attrs: {
                                      label: _vm.customLabelHandler(
                                        "Country",
                                        item
                                      ),
                                      value: item.code
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                width: "60%"
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "center-label",
                                  staticStyle: { "text-align": "right" },
                                  attrs: { title: _vm.$t("SeaExport.ZIP") }
                                },
                                [_vm._v(_vm._s(_vm.getItemTitle("ZIP")))]
                              ),
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.showPlaceholder(
                                    "SeaExport.PleaseEnterPostalCode"
                                  ),
                                  no: "consigneePostalcode"
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.synchronizeNotifier("Postalcode")
                                  }
                                },
                                model: {
                                  value: _vm.addressForm.consigneePostalcode,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.addressForm,
                                      "consigneePostalcode",
                                      $$v
                                    )
                                  },
                                  expression: "addressForm.consigneePostalcode"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ]),
                    _c("el-form-item", [
                      _c(
                        "span",
                        {
                          staticClass: "blue-text",
                          attrs: {
                            slot: "label",
                            title: _vm.$t("SeaExport.Tel")
                          },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.getItemTitle("Tel")))]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                width: "40%"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { maxlength: "14", no: "consigneeTel" },
                                on: {
                                  input: function($event) {
                                    return _vm.synchronizeNotifier("Tel")
                                  }
                                },
                                model: {
                                  value: _vm.addressForm.consigneeTel,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.addressForm,
                                      "consigneeTel",
                                      $$v
                                    )
                                  },
                                  expression: "addressForm.consigneeTel"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ]),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [_vm._v(_vm._s(_vm.getItemTitle("Notify")))]
                        ),
                        _c("cargo-company-select", {
                          staticStyle: {
                            display: "inline-block",
                            width: "200px",
                            "margin-right": "5px"
                          },
                          attrs: {
                            no: "notifyCode",
                            "method-params": { notify: true, active: true },
                            "default-value": _vm.addressForm.notifyCode || "",
                            "allow-create": true
                          },
                          on: {
                            change: function(val) {
                              _vm.addressCodeChange(val, "notify")
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              "vertical-align": "top",
                              "margin-left": "27px"
                            },
                            attrs: {
                              no: "notifyBtnAiRecognition",
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.aiRecognitionHandler(
                                  false,
                                  _vm.aiRecognitionPostHandlerByNotify,
                                  _vm.SystemConstants.AMS_AFR_PROMPT_KEY_ADDRESS
                                    .code
                                )
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.getItemTitle("Ai Recognition")))]
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              "vertical-align": "top",
                              "margin-left": "27px !important"
                            },
                            attrs: {
                              no: "notifyBtnCodeSearching",
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                _vm.billAddressDialog.visible = true
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue-text",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.getItemTitle("name")))]
                        ),
                        _c("el-input", {
                          attrs: {
                            placeholder: _vm.showPlaceholder(
                              "SeaExport.PleaseEnterHeader"
                            ),
                            "filter-chars": false,
                            no: "notifyLine1"
                          },
                          on: {
                            input: function($event) {
                              return _vm.afrValidateAddressField("notifyLine1")
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              return _vm.showSenderAndReceiverDialog(
                                "notify",
                                3
                              )
                            }
                          },
                          model: {
                            value: _vm.addressForm.notifyLine1,
                            callback: function($$v) {
                              _vm.$set(_vm.addressForm, "notifyLine1", $$v)
                            },
                            expression: "addressForm.notifyLine1"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue-text",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.getItemTitle("Address1")))]
                        ),
                        _c("el-input", {
                          attrs: {
                            placeholder: _vm.showPlaceholder(
                              "SeaExport.PleaseEnterAddress"
                            ),
                            "filter-chars": false,
                            no: "notifyLine3"
                          },
                          on: {
                            input: function($event) {
                              return _vm.afrValidateAddressField("notifyLine3")
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              return _vm.showSenderAndReceiverDialog(
                                "notify",
                                3
                              )
                            }
                          },
                          model: {
                            value: _vm.addressForm.notifyLine3,
                            callback: function($$v) {
                              _vm.$set(_vm.addressForm, "notifyLine3", $$v)
                            },
                            expression: "addressForm.notifyLine3"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [_vm._v(_vm._s(_vm.getItemTitle("Address2")))]
                        ),
                        _c("el-input", {
                          attrs: {
                            placeholder: _vm.showPlaceholder(
                              "SeaExport.PleaseEnterAddress2"
                            ),
                            "filter-chars": false,
                            no: "notifyLine4"
                          },
                          on: {
                            input: function($event) {
                              return _vm.afrValidateAddressField("notifyLine4")
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              return _vm.showSenderAndReceiverDialog(
                                "notify",
                                3
                              )
                            }
                          },
                          model: {
                            value: _vm.addressForm.notifyLine4,
                            callback: function($$v) {
                              _vm.$set(_vm.addressForm, "notifyLine4", $$v)
                            },
                            expression: "addressForm.notifyLine4"
                          }
                        })
                      ],
                      1
                    ),
                    _c("el-form-item", [
                      _c(
                        "span",
                        {
                          staticClass: "blue-text",
                          attrs: {
                            slot: "label",
                            title: _vm.$t("SeaExport.Country")
                          },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.getItemTitle("Country")))]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                width: "40%"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    filterable: "",
                                    "filter-tag-names": [
                                      "code",
                                      "chineseName",
                                      "name"
                                    ],
                                    clearable: "",
                                    placeholder: _vm.showPlaceholder(
                                      "SeaExport.PleaseSelectCountry"
                                    )
                                  },
                                  model: {
                                    value: _vm.addressForm.notifyCountry,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.addressForm,
                                        "notifyCountry",
                                        $$v
                                      )
                                    },
                                    expression: "addressForm.notifyCountry"
                                  }
                                },
                                _vm._l(_vm.countryList, function(item) {
                                  return _c("el-option", {
                                    key: item.code,
                                    attrs: {
                                      label: _vm.customLabelHandler(
                                        "Country",
                                        item
                                      ),
                                      value: item.code
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                width: "60%"
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "center-label",
                                  staticStyle: { "text-align": "right" },
                                  attrs: { title: _vm.$t("SeaExport.ZIP") }
                                },
                                [_vm._v(_vm._s(_vm.getItemTitle("ZIP")))]
                              ),
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.showPlaceholder(
                                    "SeaExport.PleaseEnterPostalCode"
                                  ),
                                  no: "notifyPostalcode"
                                },
                                model: {
                                  value: _vm.addressForm.notifyPostalcode,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.addressForm,
                                      "notifyPostalcode",
                                      $$v
                                    )
                                  },
                                  expression: "addressForm.notifyPostalcode"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ]),
                    _c("el-form-item", [
                      _c(
                        "span",
                        {
                          staticClass: "blue-text",
                          attrs: {
                            slot: "label",
                            title: _vm.$t("SeaExport.Tel")
                          },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.getItemTitle("Tel")))]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                width: "40%"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { maxlength: "14", no: "notifyTel" },
                                model: {
                                  value: _vm.addressForm.notifyTel,
                                  callback: function($$v) {
                                    _vm.$set(_vm.addressForm, "notifyTel", $$v)
                                  },
                                  expression: "addressForm.notifyTel"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ]
        ),
        _c("div", { staticClass: "section" }, [
          _c(
            "span",
            {
              staticClass: "title",
              attrs: { title: _vm.$t("SeaExport.ContainerInformation") }
            },
            [_vm._v(_vm._s(_vm.getItemTitle("House Container Information")))]
          ),
          _c(
            "div",
            { staticStyle: { display: "flex", "flex-direction": "column" } },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  staticStyle: { padding: "5px 0" }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        title: _vm.$t("SeaExport.AddContainerInformation"),
                        no: "71"
                      },
                      on: {
                        click: function($event) {
                          _vm.cargoDocUsageSelectedDialog.visible = true
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.getItemTitle("Import Container No")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        title: _vm.$t("SeaExport.AddContainerInformation"),
                        no: "89"
                      },
                      on: { click: _vm.addContainerUsageClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.getItemTitle("Add Container No")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "danger",
                        title: _vm.$t("SeaExport.RemoveContainerInformation"),
                        no: "72"
                      },
                      on: { click: _vm.removeContainerUsageClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.getItemTitle("Delete")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        title: _vm.$t("SeaExport.AiRecognition"),
                        no: "90"
                      },
                      on: {
                        click: function($event) {
                          return _vm.aiRecognitionHandler(
                            false,
                            _vm.aiRecognitionPostHandlerByCargo,
                            _vm.SystemConstants.AMS_AFR_PROMPT_KEY_CONTAINER
                              .code
                          )
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.getItemTitle("Ai Recognition")))]
                  )
                ],
                1
              ),
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%", height: "350px" },
                attrs: {
                  "config-module": "131709",
                  "grid-options": _vm.container.gridOptions,
                  "column-defs": _vm.containerColumnDefs,
                  "row-data": _vm.containerFinalRowData
                },
                on: {
                  gridReady: function(params) {
                    _vm.container.gridApi = params.api
                  }
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "section" }, [
          _c(
            "span",
            {
              staticClass: "title",
              attrs: { title: _vm.$t("SeaExport.CargoInfo") }
            },
            [_vm._v(_vm._s(_vm.getItemTitle("Cargo Information")))]
          ),
          _c(
            "div",
            { staticStyle: { display: "flex", "flex-direction": "column" } },
            [
              _c("div", { staticStyle: { padding: "5px 0" } }),
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%", height: "350px" },
                attrs: {
                  "config-module": "131708",
                  "grid-options": _vm.cargoInfomation.gridOptions,
                  "column-defs": _vm.cargoInformationColumnDefs,
                  "row-data": _vm.form.ensCargoInfo
                },
                on: {
                  gridReady: function(params) {
                    _vm.cargoInfomation.gridApi = params.api
                  }
                }
              })
            ],
            1
          )
        ])
      ]),
      _c("cargo-doc-usage-selected-dialog", {
        attrs: {
          visible: _vm.cargoDocUsageSelectedDialog.visible,
          job: _vm.job,
          "doc-type": _vm.CargoDocConsts.AFR_NEW
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cargoDocUsageSelectedDialog, "visible", $event)
          },
          callback: _vm.cargoDocUsageSelectedDialog.callback
        }
      }),
      _c("afr-address-dialog", {
        attrs: {
          visible: _vm.searchBillNoDialog.visible,
          params: _vm.searchBillNoDialog.params,
          "no-label": _vm.afrTitle,
          "no-title": _vm.afrTitleCn
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.searchBillNoDialog, "visible", $event)
          },
          selected: function(p) {
            _vm.pm.selectionItemHandler(p)
          }
        }
      }),
      _c("bill-address-dialog", {
        attrs: { visible: _vm.billAddressDialog.visible, job: _vm.job },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billAddressDialog, "visible", $event)
          },
          callback: _vm.codeSearchCallback
        }
      }),
      _c("cargo-ai-recognition-dialog", {
        attrs: {
          visible: _vm.aiRecognitionDialog.visible,
          multimodal: _vm.aiRecognitionDialog.multimodal,
          "job-uuid": _vm.aiRecognitionDialog.jobUuid,
          "doc-uuid": _vm.aiRecognitionDialog.docUuid,
          "hbl-nbr2": _vm.aiRecognitionDialog.hblNbr2,
          source: _vm.aiRecognitionDialog.source,
          "prompt-key": _vm.aiRecognitionDialog.promptKey,
          "page-source": "amsInfo",
          "i-channel": _vm.aiRecognitionDialog.iChannel,
          "call-back": _vm.aiRecognitionDialog.callBack
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.aiRecognitionDialog, "visible", $event)
          }
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "198px" },
            attrs: {
              "text-chars": 0,
              "auto-uppercase": _vm.advanceTextDialog.isUppercase,
              "auto-half-word": _vm.advanceTextDialog.formatObj.autoHalfWord,
              "warning-count": 70,
              disabled: _vm.readonly,
              no: "46"
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { type: "primary", no: "47" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "48" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.checkDialog.visible,
            title: _vm.checkDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.checkDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-ag-grid", {
            staticStyle: { height: "350px" },
            attrs: {
              "grid-options": _vm.checkDialog.gridOptions,
              "column-defs": _vm.checkDialog.columnDefs,
              "row-data": _vm.checkDialog.rowData,
              "show-side-bar": false
            },
            on: {
              gridReady: function(params) {
                _vm.checkDialog.gridApi = params.api
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }